import type { CSSProperties, ReactNode } from "react";
import { createPortal } from "react-dom";
import { classNames } from "../styles/classNames";

/** Below the anchor, growing away from the nearer window edge. */
function tooltipPosition(anchor: DOMRect): CSSProperties {
  const top = anchor.bottom;
  return anchor.left < window.innerWidth / 2
    ? { top, left: anchor.left }
    : { top, right: window.innerWidth - anchor.right };
}

/**
 * A tooltip under an element, shown while it or its anchor is hovered, or the anchor is
 * focused (`useAnchoredTooltip`).
 * It lives in a portal, so sidebars and scrolling panes don't clip it. It is visual only:
 * the element carries the same text for screen readers, by `aria-describedby` or its name.
 */
export default function AnchoredTooltip({ anchor, className, children }: { anchor: Element; className?: string; children: ReactNode }) {
  return createPortal(
    <span aria-hidden="true" data-tooltip-owner={anchor.getAttribute("data-tooltip-owner")} className={classNames("app-anchored-tooltip", className)} style={tooltipPosition(anchor.getBoundingClientRect())}>
      <span className="app-tooltip">{children}</span>
    </span>,
    document.body,
  );
}
